import { ANALYTICS_KEY } from '../../constants.js';
import '../Link/index.js';
import { ArrowText } from './ArrowText.js';
import { jsx } from 'react/jsx-runtime';
import { Link } from '../Link/Link.js';
function LinkArrow({
  ctaUrl,
  hideIcon,
  variant,
  children,
  ctaType = 'link',
  className
}) {
  const isPhone = ctaType === 'phone';
  const ctaHref = ctaType === 'email' ? ctaUrl : isPhone ? `tel:${ctaUrl}` : ctaUrl;
  return /*#__PURE__*/jsx(Link, {
    href: ctaHref,
    "data-qa": ANALYTICS_KEY.LinkArrow,
    className: className,
    children: /*#__PURE__*/jsx(ArrowText, {
      variant: variant,
      hideIcon: hideIcon,
      children: children
    })
  });
}
export { LinkArrow };
//# sourceMappingURL=LinkArrow.js.map
